import React, { useRef, useState } from 'react'
import Table from 'react-bootstrap/Table';

import './Table.css'
import { useLocation, useNavigate } from 'react-router-dom';
import { Button, Modal } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import axios from 'axios';
import CustomModel from '../CustomModel/CustomModel';
import CustomBtn from '../CustomBtn/CustomBtn';
import bank from "../../assets/bank.png"
import cash from "../../assets/money.png"
import FeesModel from '../FeesModel/FeesModel';

function index({ headerIterm, data,body, actions, path,header, acceptStatus, addExceptions, onCheckChange, showExceptions, pdf }) {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const location = useLocation();
  const handleCloseDelete = () => setShowDelete(false);
  const handleShowDelete = () => setShowDelete(true);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [showDelete, setShowDelete] = useState(false);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [statePayment, setStatePayment] = useState(false);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [statusPending, setstatusPending] = useState(false);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [imageSrc, setImgSrc] = useState(false);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [modalShowFees, setModalShowFees] = React.useState(false);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [feesId, setFeesId] = React.useState(0);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [modalShow, setModalShow] = React.useState(false);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [statex, setState] = useState('')
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [acceotRejectId, setAcceotRejectId] = useState('')
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [checkedIds, setCheckedIds] = useState([]);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [show, setShow] = React.useState(false);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [loading, setLoading] = useState(false);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [showImg, setShowImg] = useState(false);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [is_registration_fee, setIs_registration_fee] = useState(null);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const navigate = useNavigate();
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [file, setFile] = useState(null);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const inputRef = useRef(null);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { currentLocal } = useSelector((state) => state.currentLocal);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const userinfo = useSelector((state) => state);
  const handleShowImg = (img) => {
    setShowImg(true)
    setImgSrc(img)
  }
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };
  const toggleCheck = (id) => {
    let updated;
    if (checkedIds.includes(id)) {
      updated = checkedIds.filter((x) => x !== id);
    } else {
      updated = [...checkedIds, id];
    }
    setCheckedIds(updated);

    // send updated array back to parent
    if (onCheckChange) onCheckChange(updated);
  };
  return (
    <div >
      <Modal show={showImg} onHide={() => setShowImg(false)} size="lg" centered>
        <Modal.Body className="text-center">
          <img src={imageSrc} alt="full" style={{ width: "100%", height: "auto" }} />
        </Modal.Body>
        <Modal.Footer>
          <a href={imageSrc} download target="_blank" rel="noreferrer">
            <Button variant="primary">{currentLocal.home.download}</Button>
          </a>
          <Button variant="secondary" onClick={() => {setImgSrc(false)
            setShowImg(false)
          }}>
            {currentLocal.home.close}
          </Button>
          {/* زر تحميل */}

        </Modal.Footer>
      </Modal>
      <CustomModel
        show={modalShow}
        onHide={() => setModalShow(false)}
        status={statusPending}
        acceptStatus={acceptStatus}
        id={acceotRejectId}
        is_registration_fee={is_registration_fee}
      />

      <Table striped bordered hover 
    
responsive 
  className="custom-main-table"
      >
        <FeesModel
          show={modalShowFees}
          onHide={() => setModalShowFees(false)}
          feesId={feesId}
        />
{header?header:

      <thead>
          <tr>
            {headerIterm?.map((item, index) => {

              return (
                <th style={{ whiteSpace: 'nowrap' }} key={index}>{item}</th>

              )
            })}
          </tr>
        </thead>
}
  
        {body?body:
        <tbody>
          {data?.map((item) => {
console.log(item,"12455555555555");

            return (

              <tr key={item?.id || Math.random()}>
                <Modal show={show} onHide={handleClose}
                  aria-labelledby="contained-modal-title-vcenter"
                  centered
                >

                  <Modal.Body>
                    <div className="w-100 d-flex justify-content-center">
                      <div className="login_form_section_container w-100 d-flex flex-column pt-3  align-items-center"
                        style={{ cursor: "pointer" }}

                      >
                        <p className='fw-bold mb-4 text-center'>{currentLocal.home.Pleasepaytheregistrationformfee}  </p>
                        <h5 className='fw-bold'>{currentLocal.home.Chooseapaymentmethod} </h5 >
                        <div className='d-flex'>
                          {/* <div
                            className='d-flex flex-column mt-3 align-items-center  py-3 px-1 mx-2'
                            onClick={() => setState("cash")}
                            style={{
                              border: statex == "cash" ? "1px solid #e63967" : "1px solid #dee2e6"
                            }}
                          >
                            <img src={cash} alt="" className="w-25" />

                            <p className='fs-6'>
                              {currentLocal.home.Cash}
                            </p>
                          </div> */}
                          <div
                            className='d-flex flex-column mt-3 align-items-center  py-3 px-1 '
                            style={{
                              border: statex == "bank" ? "1px solid #e63967" : "1px solid #dee2e6",
                              cursor: "pointer"
                            }}
                            onClick={() => setState("bank")}
                          >
                            <img src={bank} alt="" className="w-25" />
                            <p className='fs-6'>
                              {currentLocal.home.bankAccount}

                            </p>
                          </div>
                        </div>
                        {statex == "bank" ?
                          <div>
                            <h6 className='mt-3'>{currentLocal.home.Pleasesendtheformfeetomyaccount} </h6>
                            <p className='mb-1 text-center'>0429004961810012</p>
                            <p className='fw-bold text-center'>بنك مسقط</p>
                            <p>{currentLocal.home.Pleasesendthereceipt}</p>
                            <div>

                              {/* Hidden file input */}
                              <input
                                type="file"
                                accept="image/*"
                                ref={inputRef}
                                style={{ display: "none" }}
                                onChange={handleFileChange}
                              />

                              {/* Custom button to trigger file input */}
                              <div
                                style={{ border: "1px dashed #000", height: "150px", justifyContent: "center", alignItems: "center", display: "flex", width: "350px", }}
                                onClick={() => inputRef.current.click()}
                              >
                                {file ?
                                  <div>
                                    <img
                                      src={URL.createObjectURL(file)}
                                      alt="preview"
                                      style={{ height: "100px" }}
                                    />
                                  </div>
                                  :
                                  <>

                                    <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="gray" className="bi bi-image" viewBox="0 0 16 16">
                                      <path d="M6.002 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
                                      <path d="M2.002 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm12 1a1 1 0 0 1 1 1v6.5l-3.777-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062L1.002 12V3a1 1 0 0 1 1-1z" />
                                    </svg>
                                  </>
                                }

                              </div>



                            </div>



                          </div>
                          :
                          <>
                            <p className='mt-4'>{currentLocal.home.Pleasesendthereceipt}</p>
                            <div>

                              {/* Hidden file input */}
                              <input
                                type="file"
                                accept="image/*"
                                ref={inputRef}
                                style={{ display: "none" }}
                                onChange={handleFileChange}
                              />

                              {/* Custom button to trigger file input */}
                              <div
                                style={{ border: "1px dashed #000", height: "150px", justifyContent: "center", alignItems: "center", display: "flex", width: "350px", }}
                                onClick={() => inputRef.current.click()}
                              >
                                {file ?
                                  <div>
                                    <img
                                      src={URL.createObjectURL(file)}
                                      alt="preview"
                                      style={{ height: "150px" }}
                                    />
                                  </div>
                                  :
                                  <>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="gray" className="bi bi-image" viewBox="0 0 16 16">
                                      <path d="M6.002 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
                                      <path d="M2.002 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm12 1a1 1 0 0 1 1 1v6.5l-3.777-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062L1.002 12V3a1 1 0 0 1 1-1z" />
                                    </svg>
                                  </>
                                }

                              </div>



                            </div>
                          </>
                        }
                        <div className='mt-4 w-100 '>
                          <div className='d-flex  justify-content-center align-items-center'>
                            <CustomBtn text={loading ? currentLocal.home.Loading : currentLocal.home.send} disabled={loading} type={"submit"} clickingFunction={async () => {
                              if (!file) {
                                alert("Please select an image first!");
                                return;
                              }

                              const formData = new FormData();
                              formData.append("image", file);
                              setLoading(true)
                              try {
                                const res = await axios.post(statePayment === "expenses" ? `https://nanosoft.space/taarteb/public/api/student/expenses/${item?.id}` : "https://nanosoft.space/taarteb/public/api/student/expenses", {
                                  payment_method: statex == "cash" ? 1 : 2,
                                  receipt: file,
                                  // expense_id: dataID
                                }, {
                                  headers: {
                                    "Content-Type": "multipart/form-data",
                                    Authorization: `Bearer ${userinfo.auth.userArray.access_token}`,

                                  },
                                });
                                setShow(false)
                                setLoading(false)

                              } catch (err) {
                                console.error("Upload failed:", err);
                                setLoading(false)
                              }
                            }} />

                          </div>
                        </div>

                        {/* <SignupForm/> */}
                      </div>
                    </div>
                  </Modal.Body>

                </Modal>
                {item?.id && <td>{item.id}</td>}
                {item?.student?.name && <td>{item.student.name}</td>}

                {/* {item?.student &&!location.pathname.includes=="/dashboard/finance"? <td>{item.student}</td>:<td>{item?.student?.name}</td>}   */}
                {item?.final_amount && <td>{item.expense_price}</td>}
                {item?.month && <td>{item.month}</td>}

                {item?.year && <td>{item.year}</td>}
                {item?.image && <td style={{ width: "10%", }}
                  onClick={() => handleShowImg(item?.image)}

                >

                  <img src={item.image} alt="" className='w-100' />
                </td>}

                {item?.receipt && <td style={{ width: "10%", }}
                  onClick={() => handleShowImg(item?.receipt)}

                >
                  <img src={item.receipt} alt="" className='w-100' />
                </td>}
                {item?.name && <td>{item.name}</td>}
                {item?.stage && <td>{item.stage}</td>}
                {item?.grade_category && <td>{item.grade_category?.name}</td>}
                {item?.grade?.grade_category?.name && location.pathname.includes("dashboard/expenses/exceptions/add") && <td>{item?.grade?.grade_category?.name}</td>}

                {item?.grade?.id ? <td>{item.grade.name}</td> : item?.grade && <td>{item.grade}</td>}
                {item?.class && <td>{item.class}</td>}
                {item?.email && !location.pathname.includes('expenses/exceptions') && <td>{item.email}</td>}
                {item?.email && location.pathname.includes('dashboard/expenses/exceptions/add') && <td>{item.email}</td>}
                {location.pathname.includes("/dashboard/dashboard") &&
                  <>
                    {item?.key && <td>{item.key}</td>}
                    {item?.value && <td>{item.value}{" "}{currentLocal.home.currancy}</td>}

                  </>
                }
                {item?.type && <td>{item.type}</td>}
                {item?.description && <td>{item.description}</td>}
                {item?.grade_category_name && <td>{item.grade_category_name}</td>}
                {item?.grade_name && <td>{item.grade_name}</td>}

                {item?.pivot?.notes !== undefined && (
                  <td>{item?.pivot?.notes == null ? "__________" : item?.pivot?.notes}</td>
                )}
                {item?.price && <td>{item?.price}{" "}{currentLocal.home.currancy}</td>}
                {item?.exceptions_price && <td>{item.exceptions_price ? item?.exceptions_price : item?.price}{" "}{currentLocal.home.currancy}</td>}
                {item?.salary && <td>{item.salary}</td>}
                {item?.payment_method && <td>{item.payment_method == "1" ? currentLocal.home.Cash : currentLocal.home.visa}</td>}
                {/* {item?.amount && <td>{Number(item?.amount)}</td>} */}
                {item?.amount_paid !== undefined && (
                  <td>{item?.amount_paid == null ? "0" : item?.amount_paid}{" "}{currentLocal.home.currancy}</td>
                )}
                {item?.pivot?.exception_price && <td>{item?.pivot?.exception_price}</td>}
                {item?.pay_date && <td>{item.pay_date}</td>}

                {item?.Total && <td>{item.Total}</td>}
                {item?.final_amount && <td>{item.amount_due!=null?item?.amount_due:item?.final_amount}</td>}

                {item?.date && <td>{item.date}</td>}
                {item?.employee && <td>{item.employee?.name ? item.employee?.name : item.employee}</td>}
                {item?.employee && <td>{item.employee?.phone ? item.employee?.phone : item.employee}</td>}
                {item?.employee && <td>{item.employee?.role ? item.employee?.role : item.employee}</td>}


                {item?.status && <td>{item.status=="accepted"?currentLocal.home.accept:item.status=="pending"?currentLocal.home.pending:currentLocal.home.reject}
                  <p>{item?.reason}</p>

                  <p>
                    {item.status == "rejected" && item?.reject_reason && item?.reject_reason}
                    {item.status == "rejected" && item?.rejected_reason && item?.rejected_reason}
                  </p>
                </td>}
                {pdf &&
                  <td>
                    <div className='d-flex justify-content-center align-items-center ' style={{ cursor: "pointer", flexDirection: "column" }}
                      onClick={() => {
                        window.open(pdf, "_blank");

                      }}
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" className="bi bi-cloud-download" viewBox="0 0 16 16">
                        <path d="M4.406 1.342A5.53 5.53 0 0 1 8 0c2.69 0 4.923 2 5.166 4.579C14.758 4.804 16 6.137 16 7.773 16 9.569 14.502 11 12.687 11H10a.5.5 0 0 1 0-1h2.688C13.979 10 15 8.988 15 7.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 2.825 10.328 1 8 1a4.53 4.53 0 0 0-2.941 1.1c-.757.652-1.153 1.438-1.153 2.055v.448l-.445.049C2.064 4.805 1 5.952 1 7.318 1 8.785 2.23 10 3.781 10H6a.5.5 0 0 1 0 1H3.781C1.708 11 0 9.366 0 7.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383" />
                        <path d="M7.646 15.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 14.293V5.5a.5.5 0 0 0-1 0v8.793l-2.146-2.147a.5.5 0 0 0-.708.708z" />
                      </svg>
                      <p>{currentLocal.home.downloadpdf}</p>
                    </div>
                  </td>
                }
                {location.pathname == "/dashboard/forms" &&
                  (item.status === "rejected") && (
                    <td
                      className={'pament bg-success'}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        cursor: "pointer"
                      }}
                      onClick={() => {
                        setFeesId(item?.id)
                        setModalShowFees(true)
                      }}
                    >
                      {currentLocal.home.rePay}
                    </td>
                  )}
                {item?.status == "pinding" && location.pathname == "/dashboard/student/Finance" && <td className={item?.status == "pinding" && 'pament bg-success'} style={{ display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }} onClick={() => setShow(true)}>{currentLocal.home.payNow}</td>}
                {item?.bonus !== undefined && item?.bonus !== null && (
                  <td>{item?.bonus === 0 ? "0" : item?.bonus}</td>
                )}
                {item?.bonus_reason !== undefined && (
                  <td>{item?.bonus_reason == null ? "__________" : item?.bonus_reason}</td>
                )}
                {item?.deduction !== undefined && item?.deduction !== null && (
                  <td>{item?.deduction === 0 ? "0" : item?.deduction}</td>
                )}
                {item?.deduction_reason !== undefined && (
                  <td>{item?.deduction_reason == null ? "__________" : item?.deduction_reason}</td>
                )}
                {/* {item?.bonus&& <td>{item?.bonus!=0?item?.bonus_reason:"----------"}</td>}   */}
                {/* { item?.deduction&&<td>{item?.deduction}</td>}   */}
                {/* { item?.deduction_reason&&<td>{item?.deduction!=0?item?.deduction_reason:"----------"}</td>}   */}


                {item?.total && <td>{item?.total}</td>}
                {item?.role && <td>{item.role}</td>}
                {addExceptions &&

                  <td>
                    <button className='btn btn-success' onClick={() => navigate(`/dashboard/expenses/exceptions/add/${item.id}`)}>{currentLocal.home.addExceptions}</button>
                  </td>
                }
                {showExceptions &&

                  <td>
                    <div className='d-flex justify-content-center align-items-center' style={{ cursor: "ponter" }}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" className="bi bi-eye" viewBox="0 0 16 16" onClick={() => navigate(`/dashboard/expenses/exceptions/${item?.id}`)}>
                        <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
                        <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
                      </svg>
                    </div>
                  </td>
                }
                {location.pathname.includes("dashboard/student/Finance") &&
                  item?.status === "rejected" &&

                  <td className={'pament bg-success'} style={{ display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }} onClick={() => {
                    setShow(true)
                    setStatePayment("expenses")
                  }}>{currentLocal.home.rePay}</td>

                }
                {actions?.map((actionItem, actionsIndex) => {
                  if (actionItem === "delete") {
                    return (
                      <td key={actionsIndex}>
                        <div
                          onClick={handleShowDelete}
                          style={{
                            cursor: "pointer",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            color: "red"
                          }}
                          className="mx-2"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            fill="currentColor"
                            className="bi bi-trash"
                            viewBox="0 0 16 16"
                          >
                            <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                            <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                          </svg>
                        </div>
                      </td>
                    );
                  } else if (actionItem === "view") {
                    if (location.pathname.includes("/dashboard/Dashboard")) {

                      return (
                        <td key={actionsIndex}>

                          <div onClick={() => {
                            if (item?.key == currentLocal.home.Salaries) {
                              navigate(`/dashboard/salaries`);

                            } else if (item?.key == currentLocal.home.Maintenance) {
                              navigate(`/dashboard/maintenance`);

                            } else if (item?.key == currentLocal.home.Purchases) {
                              navigate(`/dashboard/purchases`);
                            } else if (item?.key == currentLocal.home.Studyexpenses) {
                              navigate(`/dashboard/finance`);

                            }
                          }} style={{ cursor: "pointer" }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-eye" viewBox="0 0 16 16">
                              <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
                              <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
                            </svg>
                          </div>
                        </td>
                      )
                    } else {
                      return (
                        <td key={actionsIndex}>

                          <div onClick={() => {
                            navigate(`${path}${item.id}`);

                          }} style={{ cursor: "pointer" }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-eye" viewBox="0 0 16 16">
                              <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
                              <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
                            </svg>
                          </div>
                        </td>
                      )
                    }

                  } else if (actionItem === "check") {
                    return (
                      <td key={actionsIndex}>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={checkedIds.includes(item.id)}
                            onChange={() => toggleCheck(item.id)}
                          />
                        </div>
                      </td>
                    );
                  } else if (actionItem === "edit") {
                    return (
                      <td key={actionsIndex}>
                        <div className="form-check" onClick={() => {
                          navigate(acceptStatus?`/dashboard/${acceptStatus}/edite/${item?.id}`:`/dashboard/edite/${item?.id}`)
                        }}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
                            <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                            <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z" />
                          </svg>
                        </div>


                      </td>
                    )

                  } else if (actionItem === "acceptOrReject") {
                    if (item?.status !== "accepted") {
                      return (
                        <td key={actionsIndex}>
                          <div className='d-flex'>
                            <Button className='mx-3'
                              onClick={() => {
                                setModalShow(true);
                                setAcceotRejectId(item?.id)

                                setstatusPending('accept')
                                setIs_registration_fee(item?.is_registration_fee)

                              }}
                            >{currentLocal.home.accept}</Button>
                            <Button variant="danger" onClick={() => {
                              setModalShow(true);
                              setAcceotRejectId(item?.id)
                              setstatusPending('reject')
                            }}>{currentLocal.home.reject}</Button>
                          </div>
                          {/* <div className="form-check">
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
  <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
  <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"/>
</svg>
</div> */}


                        </td>
                      )
                    }
                  }
                  return null; // always return something
                })}

              </tr>
            )
          })}



        </tbody>
}
      </Table>

    </div>
  )
}

export default index